import { convert1D } from './convert1D';
import { convert2D } from './convert2D';
import convertTo3DZ from './convertTo3DZ.js';

/**
 * Extract information and data from bruker files.
 * @param {File[]} brukerFiles - Needed bruker files to parse raw data.
 * @param {object} [options = {}] - options.
 * @param {boolean} [options.xy] - if true, spectra data is a object with x and y
 * @param {boolean} [options.keepSpectra=false] - for 2D should we keep the spectra or just the matrix ?
 * @param {RegExp} [options.keepRecordsRegExp='\/.*\/'] - regular expresion to parse the metadata of the spectrum.
 * @returns
 */

export async function convertOneExperiment(brukerFiles, options = {}) {
  let result;
  if (brukerFiles.ser || brukerFiles['2rr']) {
    result = await convert2D(brukerFiles, options);
  } else if (brukerFiles['1r'] || brukerFiles['1i'] || brukerFiles.fid) {
    result = await convert1D(brukerFiles, options);
  } else {
    throw new RangeError('The current files are invalid');
  }

  result.source = {};
  for (let key in brukerFiles) {
    if ((typeof brukerFiles[key]).match(/number|string|boolean/)) {
      result.source[key] = brukerFiles[key];
    }
    // todo we could as well keep the FileList at this level if
    // we want to keep the original data
  }

  //normalizing info
  result.meta.DATE = Number(result.meta.DATE);
  if (result.meta.GRPDLY) {
    result.meta.GRPDLY = Number(result.meta.GRPDLY);
    result.meta.DSPFVS = Number(result.meta.DSPFVS);
    result.meta.DECIM = Number(result.meta.DECIM);
  }

  for (let key in result.meta) {
    if (!Array.isArray(result.meta[key])) {
      continue;
    }
    if (result.meta[key].length === 1) {
      result.meta[key] = result.meta[key][0];
    } else if (
      typeof result.meta[key][0] === 'string' &&
      result.meta[key][0].indexOf('(0..') > -1
    ) {
      result.meta[key] = result.meta[key][0];
    }
  }

  if (result.twoD) {
    result.minMax = convertTo3DZ(result.spectra);

    if (!options.keepSpectra) {
      delete result.spectra;
    }
  }

  return result;
}
